// Please maintain the order of this file as it is used in the UI
export const categories = [
  'Brave and Boundless',
  'Product Experience',
  'Live Experience',
  'Digital Experience',
  'Retail Experience',
  'Mind-blowing Creativity',
  'Innovation',
  'Transformation Catalyst',
  'Local Gems',
]

export const AllCategories = [
  'Brave and Boundless',
  'Transformation Catalyst',
  'Product Experience',
  'Mind-blowing Creativity',
  'Digital Experience',
  'Innovation',
  'Retail Experience',
  'Live Experience',
  'Local Gems',
  'Scaled Ideas',
]
export const ous = ['ASP', 'Europe', 'Global', 'INSWA', 'LATAM', 'North America', 'GCM', 'JSK', 'Africa', 'EME']

export const years = ['2023', '2024']
